import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Chip} from 'primereact/chip';
import {Chips} from 'primereact/chips';
import {InputNumber} from 'primereact/inputnumber';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';

import {ToastService} from '../../../../AppToast';
import {FormatDisplay} from '../../../../shared/format';

export default function DialogSetFormula(props) {

  const {setting, invoiceGroups, allSettings, formulaTypes, editingFormula} = props;

  const [display, setDisplay] = useState(false);

  const [formulaType, setFormulaType] = useState(null);
  const [invoiceGroup, setInvoiceGroup] = useState(null);
  const [numericColumns, setNumericColumns] = useState([]);

  const [value, setValue] = useState('');
  const [formula, setFormula] = useState([]);

  const [displayTestFormula, setDisplayTestFormula] = useState(false);
  const [parameterMap, setParameterMap] = useState({});

  const operators = [
    {value: '(', label: '('},
    {value: ')', label: ')'},
    {value: '+', label: '+'},
    {value: '-', label: '-'},
    {value: '*', label: 'x'},
    {value: '/', label: '÷'},
    {value: 'SUM', label: 'SUM'},
    {value: 'SUMIF', label: 'SUMIF'},
    {value: 'ROUND', label: 'ROUND'}
  ];

  useEffect(() => {
    if (props.display) {
      setDisplay(true);
    }
  }, [props.display]);

  useEffect(() => {
    if (setting.multipleFormula && formulaTypes && formulaTypes.length) {
      setFormulaType(formulaTypes[0].value);
    } else {
      setFormulaType(null);
    }
  }, [setting, formulaTypes]);

  useEffect(() => {
    if (editingFormula && editingFormula.formulaFe) {
      setFormula(JSON.parse(editingFormula.formulaFe));
    } else {
      setFormula([]);
    }
  }, [editingFormula]);

  useEffect(() => {
    if (allSettings && allSettings.length && invoiceGroup) {
      const _numericColumns = [];
      allSettings.forEach(set => {
        if (['int32'].includes(set.dataType) && set.groupTypeCode === invoiceGroup) {
          _numericColumns.push(set);
        }
      });
      setNumericColumns(_numericColumns);
    }
  }, [invoiceGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  const addOperator = (operator: any) => {
    const _formula = [...formula];
    _formula.push(Object.assign(operator, {type: 'operator'}));
    setFormula(_formula);
  }

  const addValue = () => {
    if (value) {
      const _formula = [...formula];
      _formula.push({value, label: value, type: 'value'});
      setFormula(_formula);
      setValue('');
    }
  }

  const addParameter = (parameter: any) => {
    const _formula = [...formula];
    _formula.push({value: parameter.id, label: parameter.lable, type: 'parameter', groupTypeCode: parameter.groupTypeCode, fieldName: parameter.fieldName});
    setFormula(_formula);
  }

  const showTestFormulaDialog = () => {
    if (formula && formula.length) {
      const _parameterMap = [];
      formula.forEach((item: any) => {
        if (item.type === 'parameter') {
          _parameterMap[item.value] = 0;
        }
      });
      setParameterMap(_parameterMap);
    }
    setDisplayTestFormula(true);
  }

  const setParameterMapValue = (parameter: string, value: number, index?: number) => {
    const _parameterMap = {...parameterMap};
    if (index) {
      _parameterMap[parameter][index] = value;
    } else {
      _parameterMap[parameter] = value;
    }
    setParameterMap(_parameterMap);
  }

  const testFormula = () => {
    let invalid = true;
    if (formula && formula.length) {
      let statement = '';

      formula.forEach((item: any) => {
        if (item.type === 'parameter') {
          statement += parameterMap[item.value];
        } else if (item.type === 'operator' && item.value === 'SUM') {
          console.log(parameterMap[item.value]);
        } else {
          statement += item.value;
        }
      });
      try {
        // eslint-disable-next-line no-eval
        const result = eval(statement);
        if (result) {
          invalid = false;
          ToastService.success(result);
        }
      } catch (e) {
      }
    }
    if (invalid) {
      ToastService.error('Công thức không hợp lệ');
    }
  }

  const handleSubmit = () => {
    props.onSubmit({formulaType, formula});
    setDisplay(false);
    setFormula([]);
  }

  const itemTemplate = (item: any) => {
    return item.label;
  }

  return (
    <Fragment>
      <Dialog header={`Cấu hình công thức [Trường: ${setting ? setting.lable : ''}]`} visible={display} style={{width: '60rem'}} onHide={() => setDisplay(false)}>
        <div className="p-fluid mt-3">
          {setting.multipleFormula &&
						<div className="field">
							<label htmlFor="formulaType">Chọn cách tính</label>
							<Dropdown id="formulaType" value={formulaType} options={formulaTypes} onChange={e => setFormulaType(e.value)}/>
						</div>
          }
          <div className="field">
            <label htmlFor="invoiceGroup">Vùng lấy dữ liệu</label>
            <Dropdown id="invoiceGroup" value={invoiceGroup} options={invoiceGroups} onChange={e => setInvoiceGroup(e.value)}/>
          </div>
          <div className="field">
            <label htmlFor="formulaType">Các giá trị số</label>
            <div style={{minHeight: 50}} className="iam card-container indigo-container p-2 pb-1">
              {
                numericColumns.map((parameter, index) => {
                  return (
                    <span key={index} onClick={() => addParameter(parameter)}>
                      <Chip label={parameter.lable} className="pointer mr-2 mb-2"/>
                    </span>
                  );
                })
              }
            </div>
          </div>

        </div>

        <div className="grid">
          <div className="col-fixed" style={{width: '450px'}}>
            <div className="field">
              <label htmlFor="formulaType">Phép tính</label>
              <div>
                {
                  operators.map((operator, index) => {
                    return <Button key={index} label={operator.label} className="p-button-outlined p-button-sm mr-2" onClick={() => {
                      addOperator(operator)
                    }}/>
                  })
                }
              </div>
            </div>
          </div>
          <div className="col p-fluid formgrid grid">
            <div className="field col">
              <label htmlFor="value">Giá trị</label>
              <InputText id="value" value={value} onChange={e => setValue(e.target.value)}/>
            </div>
            <div className="field col-fixed" style={{width: '57px'}}>
              <label style={{display: 'block'}}>&nbsp;</label>
              <Button icon="pi pi-check" className="p-button-help" onClick={addValue}/>
            </div>
          </div>
        </div>
        <div className="p-fluid">
          <div className="field">
            <Chips itemTemplate={itemTemplate} value={formula} onChange={e => setFormula(e.value)}/>
          </div>
        </div>
        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm mr-2"/>
          <Button label="Thiết lập lại" icon="pi pi-times" onClick={() => setFormula([])} className="p-button-sm p-button-danger mr-2"/>
          <Button label="Kiểm tra công thức" icon="pi pi-check-square" onClick={showTestFormulaDialog} className="p-button-sm p-button-warning mr-2"/>
          <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} className="p-button-sm"/>
        </div>
      </Dialog>
      <Dialog header={`Kiểm tra công thức [Trường: ${setting ? setting.lable : ''}]`} visible={displayTestFormula} style={{width: '50rem'}} onHide={() => setDisplayTestFormula(false)}>
        <div className="p-fluid formgrid grid mt-3">
          {
            formula.map((item, index) => {
              if (item.type === 'parameter') {
                return (
                  <div key={index} className="field col-6">
                    <label htmlFor={`parameter${index}`}>{item.label}</label>
                    <InputNumber locale={FormatDisplay.locales} inputId={`parameter${index}`} value={parameterMap[item.value]} onChange={e => setParameterMapValue(item.value, e.value)}/>
                  </div>
                )
              } else {
                return '';
              }
            })
          }
          <div className="field col-9">
            <label htmlFor="formula">Công thức</label>
            <Chips id="formula" itemTemplate={itemTemplate} value={formula} onChange={e => setFormula(e.value)} readOnly/>
          </div>
          <div className="field col-3">
            <label style={{display: 'block'}}>&nbsp;</label>
            <Button label="Tính" onClick={testFormula}/>
          </div>
        </div>
        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplayTestFormula(false)} className="p-button-text p-button-sm"/>
        </div>
      </Dialog>
    </Fragment>
  );
}
